import { combineReducers } from 'redux';

import {
    HeaderBannerDetailReducerState,
    headerBannerDetailReducer,
} from '../header-banner-detail/store/header-banner-detail-reducer';
import {
    HeaderBannerListReducerState,
    headerBannerListReducer,
} from '../header-banner-list/store/header-banner-list-reducer';

export interface HeaderBannerReducerState {
    headerBannerList: HeaderBannerListReducerState;
    headerBannerDetail: HeaderBannerDetailReducerState;
}

export const headerBannerReducer = combineReducers<HeaderBannerReducerState>({
    headerBannerList: headerBannerListReducer,
    headerBannerDetail: headerBannerDetailReducer,
});
